import { default as edit_45_91hash_93EEz6xs2l2hMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/admins/edit-[hash].vue?macro=true";
import { default as listqIU6uAHfygMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/admins/list.vue?macro=true";
import { default as view_45_91hash_93H4zLuGrc5BMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/admins/view-[hash].vue?macro=true";
import { default as analytics_45dashboardhODw0vwcruMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-dashboard.vue?macro=true";
import { default as analytics_45historyNj0JPHPCGBMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-history.vue?macro=true";
import { default as analytics_45judicial_45precedentsuEfcLUkfZOMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-judicial-precedents.vue?macro=true";
import { default as analytics_45public_45documentslv0UhxhUFHMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-public-documents.vue?macro=true";
import { default as analytics_45users_45disablesgzU4ggjforMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-disables.vue?macro=true";
import { default as analytics_45users_45monthlyKYzkoKwbJSMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-monthly.vue?macro=true";
import { default as analytics_45users_45plansa3Xrup5CLzMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-plans.vue?macro=true";
import { default as analytics_45users5kJ5zTRLSjMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users.vue?macro=true";
import { default as listYYSeSsCR7QMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/audiences/list.vue?macro=true";
import { default as view_45_91hash_93yEZDXoEMjBMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/audiences/view-[hash].vue?macro=true";
import { default as sign_45inss4PPM3H63Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/auth/sign-in.vue?macro=true";
import { default as listlDpYO3ALS6Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/banks/list.vue?macro=true";
import { default as view_45_91hash_93GMDDCfaJSsMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/banks/view-[hash].vue?macro=true";
import { default as listt9dxlz1mbDMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/claims/list.vue?macro=true";
import { default as listqzfxt6xiKRMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/companies/list.vue?macro=true";
import { default as view_45_91hash_93n1yhoiSIj9Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/companies/view-[hash].vue?macro=true";
import { default as list7bONardG9SMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/coupons/list.vue?macro=true";
import { default as view_45_91hash_93pq38GLGPp0Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/coupons/view-[hash].vue?macro=true";
import { default as listIT75h2pmYQMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/court-types/list.vue?macro=true";
import { default as view_45_91hash_93piHx6PDhOoMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/court-types/view-[hash].vue?macro=true";
import { default as listy4PhFWI0h0Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/courts/list.vue?macro=true";
import { default as view_45_91hash_93f7GpJEvlRCMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/courts/view-[hash].vue?macro=true";
import { default as dashboard2lhlU4gqdWMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/dashboard.vue?macro=true";
import { default as members_45monthlyp4RSB94S76Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/exports/members-monthly.vue?macro=true";
import { default as listQp4YSBvhypMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/faqs/list.vue?macro=true";
import { default as view_45_91hash_93Q30858VLopMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/faqs/view-[hash].vue?macro=true";
import { default as stripe_45balancekdsKxHuZJDMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/financial/stripe-balance.vue?macro=true";
import { default as stripe_45payoutKA4SThK6eeMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/financial/stripe-payout.vue?macro=true";
import { default as indexifrTee7RnIMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/index.vue?macro=true";
import { default as listOC9c3M5IDUMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judges/list.vue?macro=true";
import { default as view_45_91hash_936LbIuuXSUhMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judges/view-[hash].vue?macro=true";
import { default as listjVPkB6OqN5Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedent-affected-type/list.vue?macro=true";
import { default as view_45_91hash_93UcbKgbrDKaMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedent-affected-type/view-[hash].vue?macro=true";
import { default as featured_45listn6mxxEX2BaMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/featured-list.vue?macro=true";
import { default as listPeeTcKztaLMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/list.vue?macro=true";
import { default as listkfA3Ke650ZMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/products/list.vue?macro=true";
import { default as view_45_91hash_93P1m6HPcKGSMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/products/view-[hash].vue?macro=true";
import { default as view_45_91hash_93BsQwYoUdHQMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/view-[hash].vue?macro=true";
import { default as listC5PqLStv9PMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/labels-for-documents/list.vue?macro=true";
import { default as view_45_91hash_93v8R5YdS0adMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/labels-for-documents/view-[hash].vue?macro=true";
import { default as listldWv1qOiQyMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/lawyers/list.vue?macro=true";
import { default as view_45_91hash_93yco4XrxiX8Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/lawyers/view-[hash].vue?macro=true";
import { default as listoZUW8bNeINMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/news/list.vue?macro=true";
import { default as view_45_91hash_93Rz6lqqwjN8Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/news/view-[hash].vue?macro=true";
import { default as profilexXXY9ofRnrMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/profile.vue?macro=true";
import { default as list5VTc2dgozkMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents-types/list.vue?macro=true";
import { default as view_45_91hash_93388U2g83JzMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents-types/view-[hash].vue?macro=true";
import { default as listoWWf19zuVpMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/list.vue?macro=true";
import { default as listCp4Mb3eYbZMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/products/list.vue?macro=true";
import { default as view_45_91hash_93nQuRw8sswrMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/products/view-[hash].vue?macro=true";
import { default as view_45_91hash_93OKnoEOzemOMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/view-[hash].vue?macro=true";
import { default as edit_45_91hash_93XbwD8BpJi3Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/roles/edit-[hash].vue?macro=true";
import { default as lists7AJNAyJD6Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/roles/list.vue?macro=true";
import { default as view_45_91hash_93dMCpo2dCesMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/roles/view-[hash].vue?macro=true";
import { default as viewI3j2SOrxkoMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/settings/view.vue?macro=true";
import { default as list7YvbsnyEdXMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/stripe-products/list.vue?macro=true";
import { default as view_45_91hash_9344kCl9Csk5Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/stripe-products/view-[hash].vue?macro=true";
import { default as list0Cb3oZImROMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/tickets/list.vue?macro=true";
import { default as listnFIz1W3qifMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/users/boards-of-directors/list.vue?macro=true";
import { default as listZUvkn1a8eJMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/users/list.vue?macro=true";
import { default as listdoVnZq8bgjMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/users/products/list.vue?macro=true";
import { default as view_45_91hash_93T3WS8GCiB8Meta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/users/products/view-[hash].vue?macro=true";
import { default as view_45_91hash_93cEK5CSbsnOMeta } from "C:/Users/Viktor/Development/asufin-app-v2/pages/users/view-[hash].vue?macro=true";
export default [
  {
    name: edit_45_91hash_93EEz6xs2l2hMeta?.name ?? "admins-edit-hash",
    path: edit_45_91hash_93EEz6xs2l2hMeta?.path ?? "/admins/edit-:hash()",
    meta: edit_45_91hash_93EEz6xs2l2hMeta || {},
    alias: edit_45_91hash_93EEz6xs2l2hMeta?.alias || [],
    redirect: edit_45_91hash_93EEz6xs2l2hMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/admins/edit-[hash].vue").then(m => m.default || m)
  },
  {
    name: listqIU6uAHfygMeta?.name ?? "admins-list",
    path: listqIU6uAHfygMeta?.path ?? "/admins/list",
    meta: listqIU6uAHfygMeta || {},
    alias: listqIU6uAHfygMeta?.alias || [],
    redirect: listqIU6uAHfygMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/admins/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93H4zLuGrc5BMeta?.name ?? "admins-view-hash",
    path: view_45_91hash_93H4zLuGrc5BMeta?.path ?? "/admins/view-:hash()",
    meta: view_45_91hash_93H4zLuGrc5BMeta || {},
    alias: view_45_91hash_93H4zLuGrc5BMeta?.alias || [],
    redirect: view_45_91hash_93H4zLuGrc5BMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/admins/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: analytics_45dashboardhODw0vwcruMeta?.name ?? "analytics-analytics-dashboard",
    path: analytics_45dashboardhODw0vwcruMeta?.path ?? "/analytics/analytics-dashboard",
    meta: analytics_45dashboardhODw0vwcruMeta || {},
    alias: analytics_45dashboardhODw0vwcruMeta?.alias || [],
    redirect: analytics_45dashboardhODw0vwcruMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-dashboard.vue").then(m => m.default || m)
  },
  {
    name: analytics_45historyNj0JPHPCGBMeta?.name ?? "analytics-analytics-history",
    path: analytics_45historyNj0JPHPCGBMeta?.path ?? "/analytics/analytics-history",
    meta: analytics_45historyNj0JPHPCGBMeta || {},
    alias: analytics_45historyNj0JPHPCGBMeta?.alias || [],
    redirect: analytics_45historyNj0JPHPCGBMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-history.vue").then(m => m.default || m)
  },
  {
    name: analytics_45judicial_45precedentsuEfcLUkfZOMeta?.name ?? "analytics-analytics-judicial-precedents",
    path: analytics_45judicial_45precedentsuEfcLUkfZOMeta?.path ?? "/analytics/analytics-judicial-precedents",
    meta: analytics_45judicial_45precedentsuEfcLUkfZOMeta || {},
    alias: analytics_45judicial_45precedentsuEfcLUkfZOMeta?.alias || [],
    redirect: analytics_45judicial_45precedentsuEfcLUkfZOMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-judicial-precedents.vue").then(m => m.default || m)
  },
  {
    name: analytics_45public_45documentslv0UhxhUFHMeta?.name ?? "analytics-analytics-public-documents",
    path: analytics_45public_45documentslv0UhxhUFHMeta?.path ?? "/analytics/analytics-public-documents",
    meta: analytics_45public_45documentslv0UhxhUFHMeta || {},
    alias: analytics_45public_45documentslv0UhxhUFHMeta?.alias || [],
    redirect: analytics_45public_45documentslv0UhxhUFHMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-public-documents.vue").then(m => m.default || m)
  },
  {
    name: analytics_45users_45disablesgzU4ggjforMeta?.name ?? "analytics-analytics-users-disables",
    path: analytics_45users_45disablesgzU4ggjforMeta?.path ?? "/analytics/analytics-users-disables",
    meta: analytics_45users_45disablesgzU4ggjforMeta || {},
    alias: analytics_45users_45disablesgzU4ggjforMeta?.alias || [],
    redirect: analytics_45users_45disablesgzU4ggjforMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-disables.vue").then(m => m.default || m)
  },
  {
    name: analytics_45users_45monthlyKYzkoKwbJSMeta?.name ?? "analytics-analytics-users-monthly",
    path: analytics_45users_45monthlyKYzkoKwbJSMeta?.path ?? "/analytics/analytics-users-monthly",
    meta: analytics_45users_45monthlyKYzkoKwbJSMeta || {},
    alias: analytics_45users_45monthlyKYzkoKwbJSMeta?.alias || [],
    redirect: analytics_45users_45monthlyKYzkoKwbJSMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-monthly.vue").then(m => m.default || m)
  },
  {
    name: analytics_45users_45plansa3Xrup5CLzMeta?.name ?? "analytics-analytics-users-plans",
    path: analytics_45users_45plansa3Xrup5CLzMeta?.path ?? "/analytics/analytics-users-plans",
    meta: analytics_45users_45plansa3Xrup5CLzMeta || {},
    alias: analytics_45users_45plansa3Xrup5CLzMeta?.alias || [],
    redirect: analytics_45users_45plansa3Xrup5CLzMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users-plans.vue").then(m => m.default || m)
  },
  {
    name: analytics_45users5kJ5zTRLSjMeta?.name ?? "analytics-analytics-users",
    path: analytics_45users5kJ5zTRLSjMeta?.path ?? "/analytics/analytics-users",
    meta: analytics_45users5kJ5zTRLSjMeta || {},
    alias: analytics_45users5kJ5zTRLSjMeta?.alias || [],
    redirect: analytics_45users5kJ5zTRLSjMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/analytics/analytics-users.vue").then(m => m.default || m)
  },
  {
    name: listYYSeSsCR7QMeta?.name ?? "audiences-list",
    path: listYYSeSsCR7QMeta?.path ?? "/audiences/list",
    meta: listYYSeSsCR7QMeta || {},
    alias: listYYSeSsCR7QMeta?.alias || [],
    redirect: listYYSeSsCR7QMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/audiences/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93yEZDXoEMjBMeta?.name ?? "audiences-view-hash",
    path: view_45_91hash_93yEZDXoEMjBMeta?.path ?? "/audiences/view-:hash()",
    meta: view_45_91hash_93yEZDXoEMjBMeta || {},
    alias: view_45_91hash_93yEZDXoEMjBMeta?.alias || [],
    redirect: view_45_91hash_93yEZDXoEMjBMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/audiences/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: sign_45inss4PPM3H63Meta?.name ?? "auth-sign-in",
    path: sign_45inss4PPM3H63Meta?.path ?? "/auth/sign-in",
    meta: sign_45inss4PPM3H63Meta || {},
    alias: sign_45inss4PPM3H63Meta?.alias || [],
    redirect: sign_45inss4PPM3H63Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/auth/sign-in.vue").then(m => m.default || m)
  },
  {
    name: listlDpYO3ALS6Meta?.name ?? "banks-list",
    path: listlDpYO3ALS6Meta?.path ?? "/banks/list",
    meta: listlDpYO3ALS6Meta || {},
    alias: listlDpYO3ALS6Meta?.alias || [],
    redirect: listlDpYO3ALS6Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/banks/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93GMDDCfaJSsMeta?.name ?? "banks-view-hash",
    path: view_45_91hash_93GMDDCfaJSsMeta?.path ?? "/banks/view-:hash()",
    meta: view_45_91hash_93GMDDCfaJSsMeta || {},
    alias: view_45_91hash_93GMDDCfaJSsMeta?.alias || [],
    redirect: view_45_91hash_93GMDDCfaJSsMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/banks/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listt9dxlz1mbDMeta?.name ?? "claims-list",
    path: listt9dxlz1mbDMeta?.path ?? "/claims/list",
    meta: listt9dxlz1mbDMeta || {},
    alias: listt9dxlz1mbDMeta?.alias || [],
    redirect: listt9dxlz1mbDMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/claims/list.vue").then(m => m.default || m)
  },
  {
    name: listqzfxt6xiKRMeta?.name ?? "companies-list",
    path: listqzfxt6xiKRMeta?.path ?? "/companies/list",
    meta: listqzfxt6xiKRMeta || {},
    alias: listqzfxt6xiKRMeta?.alias || [],
    redirect: listqzfxt6xiKRMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/companies/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93n1yhoiSIj9Meta?.name ?? "companies-view-hash",
    path: view_45_91hash_93n1yhoiSIj9Meta?.path ?? "/companies/view-:hash()",
    meta: view_45_91hash_93n1yhoiSIj9Meta || {},
    alias: view_45_91hash_93n1yhoiSIj9Meta?.alias || [],
    redirect: view_45_91hash_93n1yhoiSIj9Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/companies/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: list7bONardG9SMeta?.name ?? "coupons-list",
    path: list7bONardG9SMeta?.path ?? "/coupons/list",
    meta: list7bONardG9SMeta || {},
    alias: list7bONardG9SMeta?.alias || [],
    redirect: list7bONardG9SMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/coupons/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93pq38GLGPp0Meta?.name ?? "coupons-view-hash",
    path: view_45_91hash_93pq38GLGPp0Meta?.path ?? "/coupons/view-:hash()",
    meta: view_45_91hash_93pq38GLGPp0Meta || {},
    alias: view_45_91hash_93pq38GLGPp0Meta?.alias || [],
    redirect: view_45_91hash_93pq38GLGPp0Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/coupons/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listIT75h2pmYQMeta?.name ?? "court-types-list",
    path: listIT75h2pmYQMeta?.path ?? "/court-types/list",
    meta: listIT75h2pmYQMeta || {},
    alias: listIT75h2pmYQMeta?.alias || [],
    redirect: listIT75h2pmYQMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/court-types/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93piHx6PDhOoMeta?.name ?? "court-types-view-hash",
    path: view_45_91hash_93piHx6PDhOoMeta?.path ?? "/court-types/view-:hash()",
    meta: view_45_91hash_93piHx6PDhOoMeta || {},
    alias: view_45_91hash_93piHx6PDhOoMeta?.alias || [],
    redirect: view_45_91hash_93piHx6PDhOoMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/court-types/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listy4PhFWI0h0Meta?.name ?? "courts-list",
    path: listy4PhFWI0h0Meta?.path ?? "/courts/list",
    meta: listy4PhFWI0h0Meta || {},
    alias: listy4PhFWI0h0Meta?.alias || [],
    redirect: listy4PhFWI0h0Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/courts/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93f7GpJEvlRCMeta?.name ?? "courts-view-hash",
    path: view_45_91hash_93f7GpJEvlRCMeta?.path ?? "/courts/view-:hash()",
    meta: view_45_91hash_93f7GpJEvlRCMeta || {},
    alias: view_45_91hash_93f7GpJEvlRCMeta?.alias || [],
    redirect: view_45_91hash_93f7GpJEvlRCMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/courts/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: dashboard2lhlU4gqdWMeta?.name ?? "dashboard",
    path: dashboard2lhlU4gqdWMeta?.path ?? "/dashboard",
    meta: dashboard2lhlU4gqdWMeta || {},
    alias: dashboard2lhlU4gqdWMeta?.alias || [],
    redirect: dashboard2lhlU4gqdWMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: members_45monthlyp4RSB94S76Meta?.name ?? "exports-members-monthly",
    path: members_45monthlyp4RSB94S76Meta?.path ?? "/exports/members-monthly",
    meta: members_45monthlyp4RSB94S76Meta || {},
    alias: members_45monthlyp4RSB94S76Meta?.alias || [],
    redirect: members_45monthlyp4RSB94S76Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/exports/members-monthly.vue").then(m => m.default || m)
  },
  {
    name: listQp4YSBvhypMeta?.name ?? "faqs-list",
    path: listQp4YSBvhypMeta?.path ?? "/faqs/list",
    meta: listQp4YSBvhypMeta || {},
    alias: listQp4YSBvhypMeta?.alias || [],
    redirect: listQp4YSBvhypMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/faqs/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93Q30858VLopMeta?.name ?? "faqs-view-hash",
    path: view_45_91hash_93Q30858VLopMeta?.path ?? "/faqs/view-:hash()",
    meta: view_45_91hash_93Q30858VLopMeta || {},
    alias: view_45_91hash_93Q30858VLopMeta?.alias || [],
    redirect: view_45_91hash_93Q30858VLopMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/faqs/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: stripe_45balancekdsKxHuZJDMeta?.name ?? "financial-stripe-balance",
    path: stripe_45balancekdsKxHuZJDMeta?.path ?? "/financial/stripe-balance",
    meta: stripe_45balancekdsKxHuZJDMeta || {},
    alias: stripe_45balancekdsKxHuZJDMeta?.alias || [],
    redirect: stripe_45balancekdsKxHuZJDMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/financial/stripe-balance.vue").then(m => m.default || m)
  },
  {
    name: stripe_45payoutKA4SThK6eeMeta?.name ?? "financial-stripe-payout",
    path: stripe_45payoutKA4SThK6eeMeta?.path ?? "/financial/stripe-payout",
    meta: stripe_45payoutKA4SThK6eeMeta || {},
    alias: stripe_45payoutKA4SThK6eeMeta?.alias || [],
    redirect: stripe_45payoutKA4SThK6eeMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/financial/stripe-payout.vue").then(m => m.default || m)
  },
  {
    name: indexifrTee7RnIMeta?.name ?? "index",
    path: indexifrTee7RnIMeta?.path ?? "/",
    meta: indexifrTee7RnIMeta || {},
    alias: indexifrTee7RnIMeta?.alias || [],
    redirect: indexifrTee7RnIMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: listOC9c3M5IDUMeta?.name ?? "judges-list",
    path: listOC9c3M5IDUMeta?.path ?? "/judges/list",
    meta: listOC9c3M5IDUMeta || {},
    alias: listOC9c3M5IDUMeta?.alias || [],
    redirect: listOC9c3M5IDUMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judges/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_936LbIuuXSUhMeta?.name ?? "judges-view-hash",
    path: view_45_91hash_936LbIuuXSUhMeta?.path ?? "/judges/view-:hash()",
    meta: view_45_91hash_936LbIuuXSUhMeta || {},
    alias: view_45_91hash_936LbIuuXSUhMeta?.alias || [],
    redirect: view_45_91hash_936LbIuuXSUhMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judges/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listjVPkB6OqN5Meta?.name ?? "judicial-precedent-affected-type-list",
    path: listjVPkB6OqN5Meta?.path ?? "/judicial-precedent-affected-type/list",
    meta: listjVPkB6OqN5Meta || {},
    alias: listjVPkB6OqN5Meta?.alias || [],
    redirect: listjVPkB6OqN5Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedent-affected-type/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93UcbKgbrDKaMeta?.name ?? "judicial-precedent-affected-type-view-hash",
    path: view_45_91hash_93UcbKgbrDKaMeta?.path ?? "/judicial-precedent-affected-type/view-:hash()",
    meta: view_45_91hash_93UcbKgbrDKaMeta || {},
    alias: view_45_91hash_93UcbKgbrDKaMeta?.alias || [],
    redirect: view_45_91hash_93UcbKgbrDKaMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedent-affected-type/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: featured_45listn6mxxEX2BaMeta?.name ?? "judicial-precedents-featured-list",
    path: featured_45listn6mxxEX2BaMeta?.path ?? "/judicial-precedents/featured-list",
    meta: featured_45listn6mxxEX2BaMeta || {},
    alias: featured_45listn6mxxEX2BaMeta?.alias || [],
    redirect: featured_45listn6mxxEX2BaMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/featured-list.vue").then(m => m.default || m)
  },
  {
    name: listPeeTcKztaLMeta?.name ?? "judicial-precedents-list",
    path: listPeeTcKztaLMeta?.path ?? "/judicial-precedents/list",
    meta: listPeeTcKztaLMeta || {},
    alias: listPeeTcKztaLMeta?.alias || [],
    redirect: listPeeTcKztaLMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/list.vue").then(m => m.default || m)
  },
  {
    name: listkfA3Ke650ZMeta?.name ?? "judicial-precedents-products-list",
    path: listkfA3Ke650ZMeta?.path ?? "/judicial-precedents/products/list",
    meta: listkfA3Ke650ZMeta || {},
    alias: listkfA3Ke650ZMeta?.alias || [],
    redirect: listkfA3Ke650ZMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/products/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93P1m6HPcKGSMeta?.name ?? "judicial-precedents-products-view-hash",
    path: view_45_91hash_93P1m6HPcKGSMeta?.path ?? "/judicial-precedents/products/view-:hash()",
    meta: view_45_91hash_93P1m6HPcKGSMeta || {},
    alias: view_45_91hash_93P1m6HPcKGSMeta?.alias || [],
    redirect: view_45_91hash_93P1m6HPcKGSMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/products/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93BsQwYoUdHQMeta?.name ?? "judicial-precedents-view-hash",
    path: view_45_91hash_93BsQwYoUdHQMeta?.path ?? "/judicial-precedents/view-:hash()",
    meta: view_45_91hash_93BsQwYoUdHQMeta || {},
    alias: view_45_91hash_93BsQwYoUdHQMeta?.alias || [],
    redirect: view_45_91hash_93BsQwYoUdHQMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/judicial-precedents/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listC5PqLStv9PMeta?.name ?? "labels-for-documents-list",
    path: listC5PqLStv9PMeta?.path ?? "/labels-for-documents/list",
    meta: listC5PqLStv9PMeta || {},
    alias: listC5PqLStv9PMeta?.alias || [],
    redirect: listC5PqLStv9PMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/labels-for-documents/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93v8R5YdS0adMeta?.name ?? "labels-for-documents-view-hash",
    path: view_45_91hash_93v8R5YdS0adMeta?.path ?? "/labels-for-documents/view-:hash()",
    meta: view_45_91hash_93v8R5YdS0adMeta || {},
    alias: view_45_91hash_93v8R5YdS0adMeta?.alias || [],
    redirect: view_45_91hash_93v8R5YdS0adMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/labels-for-documents/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listldWv1qOiQyMeta?.name ?? "lawyers-list",
    path: listldWv1qOiQyMeta?.path ?? "/lawyers/list",
    meta: listldWv1qOiQyMeta || {},
    alias: listldWv1qOiQyMeta?.alias || [],
    redirect: listldWv1qOiQyMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/lawyers/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93yco4XrxiX8Meta?.name ?? "lawyers-view-hash",
    path: view_45_91hash_93yco4XrxiX8Meta?.path ?? "/lawyers/view-:hash()",
    meta: view_45_91hash_93yco4XrxiX8Meta || {},
    alias: view_45_91hash_93yco4XrxiX8Meta?.alias || [],
    redirect: view_45_91hash_93yco4XrxiX8Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/lawyers/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listoZUW8bNeINMeta?.name ?? "news-list",
    path: listoZUW8bNeINMeta?.path ?? "/news/list",
    meta: listoZUW8bNeINMeta || {},
    alias: listoZUW8bNeINMeta?.alias || [],
    redirect: listoZUW8bNeINMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/news/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93Rz6lqqwjN8Meta?.name ?? "news-view-hash",
    path: view_45_91hash_93Rz6lqqwjN8Meta?.path ?? "/news/view-:hash()",
    meta: view_45_91hash_93Rz6lqqwjN8Meta || {},
    alias: view_45_91hash_93Rz6lqqwjN8Meta?.alias || [],
    redirect: view_45_91hash_93Rz6lqqwjN8Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/news/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: profilexXXY9ofRnrMeta?.name ?? "profile",
    path: profilexXXY9ofRnrMeta?.path ?? "/profile",
    meta: profilexXXY9ofRnrMeta || {},
    alias: profilexXXY9ofRnrMeta?.alias || [],
    redirect: profilexXXY9ofRnrMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: list5VTc2dgozkMeta?.name ?? "public-documents-types-list",
    path: list5VTc2dgozkMeta?.path ?? "/public-documents-types/list",
    meta: list5VTc2dgozkMeta || {},
    alias: list5VTc2dgozkMeta?.alias || [],
    redirect: list5VTc2dgozkMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents-types/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93388U2g83JzMeta?.name ?? "public-documents-types-view-hash",
    path: view_45_91hash_93388U2g83JzMeta?.path ?? "/public-documents-types/view-:hash()",
    meta: view_45_91hash_93388U2g83JzMeta || {},
    alias: view_45_91hash_93388U2g83JzMeta?.alias || [],
    redirect: view_45_91hash_93388U2g83JzMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents-types/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: listoWWf19zuVpMeta?.name ?? "public-documents-list",
    path: listoWWf19zuVpMeta?.path ?? "/public-documents/list",
    meta: listoWWf19zuVpMeta || {},
    alias: listoWWf19zuVpMeta?.alias || [],
    redirect: listoWWf19zuVpMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/list.vue").then(m => m.default || m)
  },
  {
    name: listCp4Mb3eYbZMeta?.name ?? "public-documents-products-list",
    path: listCp4Mb3eYbZMeta?.path ?? "/public-documents/products/list",
    meta: listCp4Mb3eYbZMeta || {},
    alias: listCp4Mb3eYbZMeta?.alias || [],
    redirect: listCp4Mb3eYbZMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/products/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93nQuRw8sswrMeta?.name ?? "public-documents-products-view-hash",
    path: view_45_91hash_93nQuRw8sswrMeta?.path ?? "/public-documents/products/view-:hash()",
    meta: view_45_91hash_93nQuRw8sswrMeta || {},
    alias: view_45_91hash_93nQuRw8sswrMeta?.alias || [],
    redirect: view_45_91hash_93nQuRw8sswrMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/products/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93OKnoEOzemOMeta?.name ?? "public-documents-view-hash",
    path: view_45_91hash_93OKnoEOzemOMeta?.path ?? "/public-documents/view-:hash()",
    meta: view_45_91hash_93OKnoEOzemOMeta || {},
    alias: view_45_91hash_93OKnoEOzemOMeta?.alias || [],
    redirect: view_45_91hash_93OKnoEOzemOMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/public-documents/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: edit_45_91hash_93XbwD8BpJi3Meta?.name ?? "roles-edit-hash",
    path: edit_45_91hash_93XbwD8BpJi3Meta?.path ?? "/roles/edit-:hash()",
    meta: edit_45_91hash_93XbwD8BpJi3Meta || {},
    alias: edit_45_91hash_93XbwD8BpJi3Meta?.alias || [],
    redirect: edit_45_91hash_93XbwD8BpJi3Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/roles/edit-[hash].vue").then(m => m.default || m)
  },
  {
    name: lists7AJNAyJD6Meta?.name ?? "roles-list",
    path: lists7AJNAyJD6Meta?.path ?? "/roles/list",
    meta: lists7AJNAyJD6Meta || {},
    alias: lists7AJNAyJD6Meta?.alias || [],
    redirect: lists7AJNAyJD6Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/roles/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93dMCpo2dCesMeta?.name ?? "roles-view-hash",
    path: view_45_91hash_93dMCpo2dCesMeta?.path ?? "/roles/view-:hash()",
    meta: view_45_91hash_93dMCpo2dCesMeta || {},
    alias: view_45_91hash_93dMCpo2dCesMeta?.alias || [],
    redirect: view_45_91hash_93dMCpo2dCesMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/roles/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: viewI3j2SOrxkoMeta?.name ?? "settings-view",
    path: viewI3j2SOrxkoMeta?.path ?? "/settings/view",
    meta: viewI3j2SOrxkoMeta || {},
    alias: viewI3j2SOrxkoMeta?.alias || [],
    redirect: viewI3j2SOrxkoMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/settings/view.vue").then(m => m.default || m)
  },
  {
    name: list7YvbsnyEdXMeta?.name ?? "stripe-products-list",
    path: list7YvbsnyEdXMeta?.path ?? "/stripe-products/list",
    meta: list7YvbsnyEdXMeta || {},
    alias: list7YvbsnyEdXMeta?.alias || [],
    redirect: list7YvbsnyEdXMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/stripe-products/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_9344kCl9Csk5Meta?.name ?? "stripe-products-view-hash",
    path: view_45_91hash_9344kCl9Csk5Meta?.path ?? "/stripe-products/view-:hash()",
    meta: view_45_91hash_9344kCl9Csk5Meta || {},
    alias: view_45_91hash_9344kCl9Csk5Meta?.alias || [],
    redirect: view_45_91hash_9344kCl9Csk5Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/stripe-products/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: list0Cb3oZImROMeta?.name ?? "tickets-list",
    path: list0Cb3oZImROMeta?.path ?? "/tickets/list",
    meta: list0Cb3oZImROMeta || {},
    alias: list0Cb3oZImROMeta?.alias || [],
    redirect: list0Cb3oZImROMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/tickets/list.vue").then(m => m.default || m)
  },
  {
    name: listnFIz1W3qifMeta?.name ?? "users-boards-of-directors-list",
    path: listnFIz1W3qifMeta?.path ?? "/users/boards-of-directors/list",
    meta: listnFIz1W3qifMeta || {},
    alias: listnFIz1W3qifMeta?.alias || [],
    redirect: listnFIz1W3qifMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/users/boards-of-directors/list.vue").then(m => m.default || m)
  },
  {
    name: listZUvkn1a8eJMeta?.name ?? "users-list",
    path: listZUvkn1a8eJMeta?.path ?? "/users/list",
    meta: listZUvkn1a8eJMeta || {},
    alias: listZUvkn1a8eJMeta?.alias || [],
    redirect: listZUvkn1a8eJMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/users/list.vue").then(m => m.default || m)
  },
  {
    name: listdoVnZq8bgjMeta?.name ?? "users-products-list",
    path: listdoVnZq8bgjMeta?.path ?? "/users/products/list",
    meta: listdoVnZq8bgjMeta || {},
    alias: listdoVnZq8bgjMeta?.alias || [],
    redirect: listdoVnZq8bgjMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/users/products/list.vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93T3WS8GCiB8Meta?.name ?? "users-products-view-hash",
    path: view_45_91hash_93T3WS8GCiB8Meta?.path ?? "/users/products/view-:hash()",
    meta: view_45_91hash_93T3WS8GCiB8Meta || {},
    alias: view_45_91hash_93T3WS8GCiB8Meta?.alias || [],
    redirect: view_45_91hash_93T3WS8GCiB8Meta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/users/products/view-[hash].vue").then(m => m.default || m)
  },
  {
    name: view_45_91hash_93cEK5CSbsnOMeta?.name ?? "users-view-hash",
    path: view_45_91hash_93cEK5CSbsnOMeta?.path ?? "/users/view-:hash()",
    meta: view_45_91hash_93cEK5CSbsnOMeta || {},
    alias: view_45_91hash_93cEK5CSbsnOMeta?.alias || [],
    redirect: view_45_91hash_93cEK5CSbsnOMeta?.redirect || undefined,
    component: () => import("C:/Users/Viktor/Development/asufin-app-v2/pages/users/view-[hash].vue").then(m => m.default || m)
  }
]